// Client-side UI maps for things the API doesn't return:
// icons for sources, badge colors for statuses, and the fixed tab order.
// Labels (`name`) come from the API list endpoint's `filter` block.

export const SOURCE_ICONS = {
  dine_in:  'fa-solid fa-utensils',
  takeaway: 'fa-solid fa-bag-shopping',
  delivery: 'fa-solid fa-motorcycle'
};

export const STATUS_COLORS = {
  unpaid:              'warning',
  partially_paid:      'info',
  paid:                'success',
  platform_pending:    'info',
  partially_refunded:  'warning',
  refunded:            'danger',
  voided:              'secondary'
};

// Viewpoints supported by the list API.
export const TAB_ORDER = ['all', 'unpaid', 'partially_paid', 'paid', 'platform_pending'];

// "partially_paid" → "Partially Paid"
export function humanize(value) {
  if (!value) return '';
  return String(value)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
}
